import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import FeedbackService from 'services/FeedbackService'

export const initialState = {
  loading: false,
  sucesso: false,
  erro: null,
}

export const enviarFeedback = createAsyncThunk(
  'feedback/enviar',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await FeedbackService.enviar(formData)
      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erro ao enviar feedback')
    }
  }
)

export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    resetarFeedback: (state) => {
      state.loading = false
      state.sucesso = false
      state.erro = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(enviarFeedback.pending, (state) => {
        state.loading = true
        state.sucesso = false
        state.erro = null
      })
      .addCase(enviarFeedback.fulfilled, (state) => {
        state.loading = false
        state.sucesso = true
      })
      .addCase(enviarFeedback.rejected, (state, action) => {
        state.loading = false
        state.erro = action.payload
      })
  },
})

export const { resetarFeedback } = feedbackSlice.actions
export default feedbackSlice.reducer
